import { BarColors } from "./PowerBarChartProps";

/**
 * 透過 getBarColor 可以根據 `正負值` 和 `與前一個值得關係` 取得當前柱狀條的顏色
 *
 * @param barColors - 柱狀條的四種顏色:
 * - [正數上升、正數下降、負數上升、負數下降]
 * @param currentVal - 該柱狀條的目前值
 * @param prevVal - 該柱狀條的上一個值
 * @returns string - 柱狀條的顏色
 */
export const getBarColor = (
  barColors: BarColors,
  currentVal: number,
  prevVal: number | null | undefined
): string => {
  if (prevVal == null)
    return currentVal >= 0
      ? barColors.positiveAscColor
      : barColors.negativeAscColor;

  if (currentVal >= prevVal)
    return currentVal >= 0
      ? barColors.positiveAscColor
      : barColors.negativeAscColor;

  return currentVal >= 0
    ? barColors.positiveDescColor
    : barColors.negativeDescColor;
};
